module.exports = __webpack_public_path__ + "media/step3_animation.a7cfc51e.webm";